<template>
    <v-container>
        <div v-if="config">
            <v-card
            class="pa-3"
            v-if="config"
            
            v-for="(editorId, key) in config.editors"
            :key="key"
            >
            
            <div v-if="usersDict">
                <div>{{usersDict[editorId].firstname}} {{usersDict[editorId].lastname}}</div>
                <div>{{usersDict[editorId].email}}</div>
                <div class="caption text--grey">{{editorId}}</div>
                <v-btn text color="red" @click="removeEditor(editorId)">Revoke Access</v-btn>
            </div>



            

        </v-card>
        <v-autocomplete
        
                label="Select Email to Add"
                outlined
                :items="usersArray"
                item-text="email"
                item-value="id"      
                @change="addEditor"
                clearable
                class="mt-10"

                >


            </v-autocomplete>

        </div>


        

    </v-container>


</template>
<script>
import firebase from 'firebase'

export default {
    name: 'AdminManagement',
    data() {
        return {
            config: null,
            usersDict: null,
            usersArray: null
        }
    },
    mounted() {
        let queries = [
            firebase.firestore().collection('adminAuth').doc('config').get(),
            firebase.firestore().collection('users').get()
        ]
        Promise.all(queries).then(results => {
            this.config = results[0].data()
            let usersDict = {}
            let usersArray = []
            results[1].forEach(doc => {
                usersDict[doc.id] = doc.data()
                let user = doc.data()
                user.id = doc.id
                usersArray.push(user)
            })
            this.usersDict = usersDict
            this.usersArray = usersArray
        })

    },
    methods: {
        addEditor(id) {
            var docRef = firebase.firestore().collection("adminAuth").doc("config");

            // Atomically add a new region to the "regions" array field.
            docRef.update({
                editors: firebase.firestore.FieldValue.arrayUnion(id)
            }).then(() => {
                location.reload();

            })
            
        },
        removeEditor(id) {
            var docRef = firebase.firestore().collection("adminAuth").doc("config");

            // Atomically add a new region to the "regions" array field.
            docRef.update({
                editors: firebase.firestore.FieldValue.arrayRemove(id)
            }).then(() => {
                location.reload();

            })

        }
    }
}
</script>